// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__dYzYP","title":"Images90_title__1hqnH","images":"Images90_images__1-LHl"};